// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';
import ImportFileReportDashboardContent from './Izenda.ImportFileReportDashboardContent';

export default class ImportFileContent {
  @observable id: string = null;
  @observable name: string = null;
  @observable content: ImportFileReportDashboardContent = null;
  @observable saveIntoId: string = null;

  @observable categories: Array<any> = [];
  @observable subCategories: Array<any> = [];

  isReport: boolean = false;

  constructor(data: any, localCategoryId: string, isReport: boolean) {
    this.id = data.id;
    this.name = data.name;
    this.content = new ImportFileReportDashboardContent(data.content);
    this.saveIntoId = localCategoryId;
    this.isReport = isReport;
  }

  /**
   * Buid data
   */
  buildData() {
    return {
      content: this.content.buildData(),
      id: this.id,
      name: this.name
    };
  }

  /**
   * Update save into id
   * @param {String} saveIntoId
   */
  @action
  updateSaveIntoId(saveIntoId: string) {
    this.saveIntoId = saveIntoId;
  }

  /**
   * Update category
   * @param {String} categoryId
   */
  @action
  updateCategory(categoryId: string, categoryName: string) {
    this.content.categoryId = categoryId;
    this.content.categoryName = categoryName;
  }

  /**
   * Update sub-category
   * @param {String} subCategoryId
   */
  @action
  updateSubCategory(subCategoryId: string, subCategoryName: string) {
    this.content.subCategoryId = subCategoryId;
    this.content.subCategoryName = subCategoryName;
  }
}


// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportFileContent.js